import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'profileTypeLabel',
    standalone: false
})
export class ProfileTypeLabelPipe implements PipeTransform {
  transform(profileType: string, profileTypes: any[]): string {
    let value = profileType;
    for(let pt of profileTypes) {
      if (pt.reference === profileType) {
        value = pt.label;
        break;
      }
    }
    return value;
  }
}
